import type { QueryClient } from '@tanstack/react-query';
import { createRootRouteWithContext, Link, Outlet } from '@tanstack/react-router';
import { TanStackRouterDevtools } from '@tanstack/react-router-devtools';

import { Button } from '@/components/Button/Button';
import { showDevChrome } from '@/lib/devChrome';

export interface RouterContext {
    queryClient: QueryClient;
}

// No app shell at the root on purpose: the login screens are bare, and the admin areas
// sit under the pathless _app layout, which checks the session and wraps them in AppShell.
export const Route = createRootRouteWithContext<RouterContext>()({
    component: RootLayout,
    notFoundComponent: NotFound,
});

function RootLayout() {
    return (
        <>
            <Outlet />
            {showDevChrome() ? <TanStackRouterDevtools position="bottom-right" /> : null}
        </>
    );
}

function NotFound() {
    return (
        <main className="flex min-h-svh flex-col items-center justify-center gap-5 px-6 text-center">
            <div className="flex flex-col gap-2">
                <h1 className="text-page-title text-foreground">Page not found</h1>
                <p className="text-muted-foreground text-sm">That route does not exist yet.</p>
            </div>
            <Button asChild variant="outline">
                <Link to="/dashboard">Go to the dashboard</Link>
            </Button>
        </main>
    );
}
